import graphql__90df1f2adc99df0f8c6d from "./__generated__/DeleteCustomerDialog_customerAccount.graphql.ts";
import graphql__c59d8253e24d74cbbe28 from "./__generated__/DeleteCustomerDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import Hint from "../presentational/Hint";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type DeleteCustomerDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const DeleteCustomerDialog: React.FC<DeleteCustomerDialogProps> = (props) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const customerAccount = useFragment(
        graphql__90df1f2adc99df0f8c6d,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__c59d8253e24d74cbbe28,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    if (!errors || errors.length === 0) {
                        new Promise(resolve => setTimeout(resolve, 3000)).then(() => navigate('/customers'));
                    }
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteCustomer'})
            }
        )
    }

    const initialValues = {
        id: customerAccount.id
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.DeleteCustomerDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.DeleteCustomerDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeleteCustomerDialog.confirmMessage'}, {name: customerAccount.customerName})}
                    </p>
                </Row>
                <Row>
                    <Hint>
                        {intl.formatMessage({id: 'dialog.DeleteCustomerDialog.warning'})}
                    </Hint>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeleteCustomerDialog;
